import { ThunkDispatch } from 'redux-thunk'
import { connect } from 'react-redux'
import { AnyAction } from 'redux'

import { IDispatchProps } from '../types'
import { fetchUsers } from '../../../../store/users/actions'
import { fetchInstallations } from '../../../../store/installations/actions'
import { IState } from '../../../../store/types'
import { Display } from './Display'
import { IStateProps } from '../types'

const mapStateToProps = (state: IState): IStateProps => {
  return {
    users: state.users,
    installations: state.installations,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IDispatchProps => {
  return {
    fetchUsers: () => {
      return dispatch(fetchUsers())
    },
    fetchInstallations: () => {
      return dispatch(fetchInstallations())
    }
  }
}

const DisplayContainer = connect(mapStateToProps, mapDispatchToProps)(Display)

export {
  DisplayContainer
}
